var checkbox = $("input[type='checkbox']");
var submitButt = $("button[type='submit']");

checkbox.click(function() {
    submitButt.attr("disabled", !checkbox.is(":checked"));
});

$('.navbar-nav').on('click', '.nav__link', function() {
    $('.nav__link').removeClass('nav--is-activated');
    $(this).addClass('nav--is-activated');
});

$(document).on('click','.navbar-collapse.show',function(e) {
    if( $(e.target).is('a.nav__link')) {
        $('#menu-burger-icon i').removeClass('fa fa-times');
        $('#menu-burger-icon i').addClass('fa fa-bars');
        $(this).collapse('hide');
    }
});
